export async function compressImageToJpeg(file: File, maxSizeKB: number): Promise<File> {
    const img = new Image();
    img.src = URL.createObjectURL(file);
    await new Promise<void>((resolve, reject) => {
        img.onload = () => resolve();
        img.onerror = reject;
    });

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    if(!ctx) { throw new Error("Could not create canvas context"); }

    // Maintain aspect ratio
    canvas.width = img.width;
    canvas.height = img.height;
    ctx.drawImage(img, 0, 0);

    let quality = 0.9;
    let blob: Blob | null = null;

    // Keep reducing quality until under maxSizeKB or quality too low
    while (quality >= 0.01) {
        blob = await new Promise<Blob | null>((resolve) =>
            canvas.toBlob( (b) => resolve(b),
                "image/jpeg", quality
            )
        );
        if(blob && blob.size / 1024 <= maxSizeKB) { break; }
        console.log("Size: " + ((blob?.size ?? -1) / 1024.0) + "kb");
        quality *= 0.4;
    }

    if(!blob) { throw new Error("Compression failed"); }
    console.log("Compression completed");
    return new File([blob], file.name.replace(/\.[^.]+$/, ".jpeg"), {
        type: "image/jpeg",
    });
}
